(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue-monaco"));
	else if(typeof define === 'function' && define.amd)
		define(["vue-monaco"], factory);
	else if(typeof exports === 'object')
		exports["client"] = factory(require("vue-monaco"));
	else
		root["client"] = factory(root["vue-monaco"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__68c9__) {
return 